const key = "more-info-text";

export const moreInfoText = {
    key: key,
    init: (value) => {

        let styleEl = document.getElementById(`${key}-style`);
        if(!styleEl) {
            styleEl = document.createElement("style");
            styleEl.id = `${key}-style`
            // Append <style> element to <head>
            document.head.appendChild(styleEl);
        }
        
        const styleSheet = styleEl.sheet;
        switch(value){
            case 'text':
                styleSheet.insertRule(`
                    .tooltip + .helptext {
                        display: block !important;
                        margin-left: var(--spacing-2);
                    }`, 0);
                styleSheet.insertRule(`
                    .tooltip {
                        display: none !important;
                    }`, 0);
                break;
            case 'lower-text':
                styleSheet.insertRule(`
                    product-variations + .helptext,
                    .optionValues + .helptext {
                        display: inline-block !important;
                    }`, 0);
                styleSheet.insertRule(`
                    .tooltip {
                        display: none !important;
                    }`, 0);
                break;
        }   
    }
}
